import { PrimaryButton } from "components/Button/style";
import styled from "styled-components";

export const ContainerCinza = styled.div`
  margin-bottom: 24px;
  width: 100%;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.neutral.neutral05};
`;

export const ContainerTitle = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const ContainerStatus = styled.div`
  display: flex;
  line-height: 15px;
  gap: 10px;
`;

export const Title = styled.span`
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  letter-spacing: 0%;
`;

export const RadioContainer = styled.div`
  display: flex;
  gap: 24px;

  span {
    display: flex;
    align-items: center;
  }

  input {
    accent-color: ${({ theme }) => theme.colors.project.main};
    margin-right: 8px;
    width: 1rem;
    height: 10px;
  }
`;

export const InputCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 0.5rem;
  margin-bottom: 24px;
`;

export const IconeAdicionar = styled.span`
  padding: 1px;
  border-radius: 30px;
  color: ${({ theme }) => theme.colors.white};
  background-color: #10ac85;

  svg {
    width: 15px;
    height: 10px;
    margin-bottom: 2px;
  }
`;

export const ContainerBtnSubmit = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
`;

export const Button = styled(PrimaryButton)`
  width: 120px;
  margin-left: 16px;
`;

export const ContainerFormProcessoFinanceiro = styled.div`
  margin-bottom: 24px;
`;

export const ContainerBtnFormProcessoFinanceiro = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
`;

export const TituloCampoProcessoFinanceiro = styled.div`
  margin-bottom: 10px;
`;
